export default "__VITE_ASSET__61585433__"